module.exports = __webpack_public_path__ + "static/filintomota-063fec6e919602a610d8e87abe09f519.png";